export const SEARCH_MATCHES_REQUEST = 'searchMatchesRequest';
export const SEARCH_MATCHES_FAILURE = 'searchMatchesFailure';
export const SEARCH_MATCHES_SUCCESS = 'searchMatchesSuccess';
export const REMOVE_SEARCH = 'removeSearch';
export const GET_BETS_BY_MATCH_FAILURE = 'getBetsByMatchFailure';
export const GET_BETS_BY_MATCH_SUCCESS = 'getBetsByMatchSuccess';
export const GET_BETS_BY_MATCH_0_BETS = 'getBetsByMatch0Bets';
export const GET_BETS_BY_MATCH_REQUEST = 'getBetsByMatchRequest';
export const CLEAR_CURRENT_MATCH_BETS = 'clearCurrentMatchBets';
